import React, { useEffect, useState, useContext } from 'react';
import './GHGEmissions.scss';
import { withTranslation } from 'react-i18next';
import { Button, Modal, Table } from 'react-bootstrap';
import { toast } from "react-toastify";
import { LoaderContext } from '../../../App';
import GHGEmissionService from '../../../core/service/GHGEmissionService';
import { DEFAULT_ITEMS_PER_PAGE } from '../../../core/constants/common';
import Pagination from '../../../components/Pagination/Pagination';
import { FcFinePrint } from "react-icons/fc";

const CategorySearch = ({ t, db, onShowModal, onHideModal, onAddCategory }) => {

    const { setLoaderDisplay } = useContext(LoaderContext);
    const [itemsTotalCount, setItemTotalCount] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(DEFAULT_ITEMS_PER_PAGE);
    const [currentPage, setCurrentPage] = useState(1);
    const [showModal, setShowModal] = useState(onShowModal);
    const [factorsList, setFactorsList] = useState([]);
    const [searchKey, setSearchKey] = useState('');
    const [selectedRow, setSelectedRow] = useState(null);

    useEffect(() => {
        getFactors(0, itemsPerPage)
    }, []);

    const getFactors = (pageNumber, itemsPerPageVal) => {
        let perPage = '';
        if (pageNumber > 0) {
            pageNumber = pageNumber - 1;
        } else {
            setCurrentPage(1);
        }
        if (itemsPerPageVal > 0) {
            perPage = itemsPerPageVal;
        } else {
            perPage = itemsPerPage;
        }
        setLoaderDisplay(true);
        GHGEmissionService.getFatorsList(
            db,
            pageNumber,
            perPage,
            searchKey
        ).then((response) => {
            const totalPages = parseFloat(response.headers["x-total-count"]);
            setItemTotalCount(totalPages);
            setFactorsList(response.data);
            setLoaderDisplay(false);
        })
            .catch((error) => {
                setLoaderDisplay(false);
            });
    };

    const renderEmptyDataLabel = () => {
        return (
            <tr className="Nodatafound_box">
                <td colSpan={4} className='text-center'><FcFinePrint className="me-2" />{t("Nodatafound.label")}</td>
            </tr>
        )
    };

    const addCategory = () => {
        if (selectedRow != null) {
            onAddCategory(selectedRow);
            onHideModal(false);
        } else {
            toast.warning('Please choose any category', {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
    };

    return (
        <div>
            <Modal className='CategorySearch_modal' show={showModal} onHide={() => onHideModal(false)} size="xl">
                <Modal.Header closeButton>
                    < Modal.Title as="h5">{t("CategorySearch.label")}</Modal.Title>
                </Modal.Header>
                <Modal.Body className='py-0'>
                    <div className='row m-0'>
                        <div className='col-md-6 p-2'>

                            <input className='form-control' value={searchKey} placeholder='Search with title'
                                onChange={(e) => setSearchKey(e.target.value)} maxLength={50} onKeyDown={(e) => {
                                    if (e.key === "Enter")
                                        getFactors(0, itemsPerPage);
                                }} />
                        </div>
                    </div>

                    <div className='p-2 pt-1 pb-0'>
                        <Table bordered responsive className='m-0'>
                            <thead>
                                <tr>
                                    <th>Title</th>
                                    <th className='text-center'>Ref USEEIO Code</th>
                                    <th className='text-center'>Emission Factor</th>
                                    {/* <th className='text-center'>Action</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {factorsList.length > 0 ? (
                                    factorsList.map((item, index) => (
                                        <tr key={item.id} className={`cursor ${(selectedRow?.id == item?.id) ? 'bg-selected-row' : ''}`}>
                                            <td className='cursor' onClick={() => setSelectedRow(item)}>{item.title}</td>
                                            <td className='text-center'>{item.refUSEEIOCode}</td>
                                            <td className='text-center'>{item.factorWithMargins}</td>
                                            {/* <td className='text-center'>
                                                <Button variant='primary' className='px-3' onClick={() => addCategory(item)}>{t("Add.label")}</Button>
                                            </td> */}
                                        </tr>
                                    ))
                                ) :
                                    renderEmptyDataLabel()
                                }
                            </tbody>
                        </Table>

                        <div className="py-2 List_footer_count">
                            <Pagination
                                itemsTotalCount={itemsTotalCount}
                                itemsPerPage={itemsPerPage}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                                alwaysShown={true}
                                setItemsPerPage={setItemsPerPage}
                                pageClicked={(pageNum, perPage) => {
                                    getFactors(pageNum, perPage);
                                }}
                            />
                        </div>
                    </div>


                </Modal.Body>
                <Modal.Footer className='p-1'>
                    <Button variant="secondary" className='px-4' onClick={() => onHideModal(false)}>
                        {t("Close.label")}
                    </Button> &nbsp;&nbsp;
                    <Button variant='primary' className=' px-4' onClick={() => addCategory()}>{t("Add.label")}</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default withTranslation()(CategorySearch);